import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';

interface ShiftAtomState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    prevDocumentId: any;
    clientId: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    relatedPlansList: any[];
    prevPlansList: any[];

    targetForDelete: any[];
    // inWorkStatus: any;
    // formationStatus: any;
    // products: any[];
    remains: any[];
    meta: any;
}

const state: ShiftAtomState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    prevDocumentId: null,
    clientId: null,

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    relatedPlansList: [],
    prevPlansList: [],

    targetForDelete: [],
    // products: [],
    remains: [],
    meta: {}
};

const initState: any = cloneDeep(state);

const PL_RELAED_PRODUCTS_LIST = 'PL_RELAED_PRODUCTS_LIST';
const PREV_SHIFT_LIST = 'PREV_SHIFT_LIST';
const GET_SCHEMA = 'GET_SCHEMA';

function getBasketItem(state: ShiftAtomState, saved: any, relTimeOfDay: string) {
  if (saved) {
    return {
      id: saved.id,
      number: saved.number,
      container_name: saved.container_name,
      remains_container_name: saved.remains_container_name,
      product_name: saved.product_name,
      quantity: saved.quantity,
      mark_type: saved.mark_type,
      legal: saved.legal,
      plan_weight: saved.plan_weight,
      remains_plan_weight: saved.remains_plan_weight,
      common_weight: saved.common_weight,
      technology: saved.technology,
      coock_number: saved.coock_number,
    };
  } else {
    const letter = relTimeOfDay ? relTimeOfDay[0] : ''
    return {
      id: Math.random(),
      number: (state.relatedPlansList.length + 1) + letter,
      container_name: null,
      remains_container_name: null,
      product_name: null,
      quantity: null,
      mark_type: null,
      legal: null,
      plan_weight: null,
      remains_plan_weight: null,
      common_weight: null,
      technology: null,
      coock_number: null,
    }
  }

}

export const actions: ActionTree<ShiftAtomState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, clientId, remains, realEndTime, relTimeOfDay }) {
        const vm = (this as any)._vm;
        console.log('relTimeOfDay', relTimeOfDay)

        state.documentId = documentId;
        state.clientId = clientId;
        state.remains = remains;

        return new Promise((resolve, reject) => {
          commit('START_LOADING');
          vm.$db([
            vm.$q(PL_RELAED_PRODUCTS_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sa.id',
                  number: 'sa.number',
                  coock_number: {$concat: ['sacp.number', {$: " ("}, 'pp.name', {$: ")"}]},
                  container_name: 'vc.name',
                  container_weight: 'vc.weight',
                  remains_container_name: 'vcr.name',
                  remains_container_weight: 'vcr.weight',
                  product_name: {$concat: ['p.name', {$: " "}, 'pc.name']},
                  quantity: 'sa.quantity',
                  plan_weight: 'sa.plan_weight',
                  remains_plan_weight: {$sub: ['sa.common_weight', 'sa.plan_weight']},
                  mark_type: 'sa.mark_type',
                  legal: 'sa.legal',
                  common_weight: 'sa.common_weight',
                  technology: 'sa.technology',
                },
                from: 's:shift_atom',
                from_as: 'sa',
                joins: [
                  {
                    join: 's:voc_containers',
                    type: 'left',
                    as:   'vc',
                    on: {
                      $eq: ['sa.container_id', 'vc.id']
                    }
                  },
                  {
                    join: 's:voc_containers',
                    type: 'left',
                    as:   'vcr',
                    on: {
                      $eq: ['sa.remains_container_id', 'vcr.id']
                    }
                  },
                  {
                    join: 's:products',
                    type: 'left',
                    as:   'p',
                    on: {
                      $eq: ['sa.product_id', 'p.id']
                    }
                  },
                  {
                    join: 's:product_containers',
                    type: 'left',
                    as:   'pc',
                    on: {
                      $eq: ['sa.product_container_id', 'pc.id']
                    }
                  },
                  {
                    join: 's:shift_atom_coock_plan',
                    type: 'left',
                    as:   'sacp',
                    on: {
                      $eq: ['sa.coock_plan_id', 'sacp.id']
                    }
                  },
                  {
                    join: 's:produced_products',
                    type: 'left',
                    as:   'pp',
                    on: {
                      $eq: ['sacp.product_id', 'pp.id']
                    }
                  },
                ],
                order: [
                  {$asc: ['sa.id']}
                ],
                page: 1,
                page_size: 1000,
                where: {
                  $eq: [`sa.shift_id`, {$: documentId}]
                }
              }),
              vm.$q(GET_SCHEMA)
              .raw('schemas.get')
              .action({
                  id: `s:shift_atom`
              }),
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(PL_RELAED_PRODUCTS_LIST);
            const opRelSchema = result.getOperation(GET_SCHEMA);
            if (!opRelSchema.hasError()) {
              state.meta = fetchEnumsFromSchema(opRelSchema.getContent().schema)
            }
            if (!opRelResult.hasError()) {
              state.relatedPlansList = opRelResult.getContent().documents.map((doc: any) => {
                if (doc.remains_container_weight) {
                  const _c1 = doc.quantity
                  const _c2 = Math.floor((doc.common_weight - _c1 * doc.container_weight) / doc.remains_container_weight)
                  doc.plan_weight = [_c1, _c2]
                } else {
                  doc.plan_weight = [doc.quantity, null]
                }
                return getBasketItem(state, doc, relTimeOfDay)
              }).filter((item: any) => {
                return !realEndTime || item.fact_id
              });
              // state.prevPlansList = opPrevResult.getContent().documents.map((doc: any) => {
              //   return getBasketItem(state, doc, relTimeOfDay)
              // });
              // state.prevDocumentId = state.prevPlansList[0] ? state.prevPlansList[0].shift_id : null;
              // console.log('prevDocumentId => ', state.prevDocumentId)
            }
            commit('LOADED_SUCCESS');

            resolve(null);
          });
        })
    },


    addItem({ state }, relTimeOfDay) {
      console.log('relTimeOfDay', relTimeOfDay)
      state.relatedPlansList.push(
        getBasketItem(state, null, relTimeOfDay)
      )
    },

    removeItem({ state }, index: number) {
        if (state.relatedPlansList[index].id) {
            state.targetForDelete.push(state.relatedPlansList[index].id)
        }

        state.relatedPlansList.splice(index, 1);
    },

    changeFormValue({ state, commit }, { index, field, newValue}) {
      commit('SET_FROM_DATA', {index, field, newValue})
    },

    saveForm({ state, dispatch }, {realEndTime}) {
      const vm = (this as any)._vm;
      const allowedFields = ['id', 'base_id', 'number', 'attachments', 'starter_type_id'];

      return new Promise((resolve, reject) => {
        const normalizedItemsData = state.relatedPlansList.map((item, index) => {
          console.log('n => ', item);
          const cleanDocuemnt: any = Object.keys(item)
          .filter((key: string) => allowedFields.includes(key))
          .reduce((obj: any, key: string) => {
              console.log('key => ', key, obj);
              if (key == 'id') {
                console.log('d1 => ', item[key]);
                item[key] = (typeof(item[key]) == 'string') ? item[key] : null;
                console.log('d2 => ', item[key]);
              }
              obj[key] = item[key];
              return obj;
            }, {});

          console.log('d => ', cleanDocuemnt);
          return cleanDocuemnt;
        });

        const queries = [
          vm.$q(`SAVE_DEAL_BASKET`)
            .update(state.documentId, {})
            .createManyRelation('shift_plan_vdp', 'shift_id', (createRelated: any) => {
              return normalizedItemsData.filter((item: any) => !item.id || (typeof(item.id) !== 'string')).map((item, index) => createRelated(item));
            })
            .updateManyRelation('shift_plan_vdp', 'shift_id', (updateRelated: any) => {
              return normalizedItemsData.filter((item: any) => (typeof(item.id) == 'string')).map((item, index) => updateRelated(item))
            })
        ]

        vm.$db(queries)
          .then((result: ServerResult) => {
            const totalSaveRes = !result.getOperation(`SAVE_DEAL_BASKET`).hasError();
            if (totalSaveRes) {
              state.targetForDelete = [];

              dispatch('loadData', { documentId: state.documentId, realEndTime})
                .then(() => {
                  resolve();
                })
            } else {
              reject();
            }
          });
      })
    },

    
    exportAsXLSX({rootState, state}, {documentId}) {
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
          vm.$db([
              vm.$q('EXPORT')
              .raw('documents.report')
              .action({
                template: `
<!DOCTYPE html>
<table font=Verdana font-size=10 orientation="portrait" area="A:K" scale="45">
<tr height=30>
  <td wrap border bold bgcolor=FF72BF44 width=10>ID</td>
  <td wrap border bold bgcolor=FF72BF44 width=25>Номер</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Тара</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Продукт</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Количество</td>
</tr>
{{#plan.documents}}
  <tr height="auto">
    <td wrap border base >{{id}}</td>
    <td wrap border base >{{number}}</td>
    <td wrap border base >{{container_name}}</td>
    <td wrap border base >{{product_name}}</td>
    <td wrap border base round align=center>{{quantity}}</td>
  </tr>
{{/plan.documents}}
</table>
                `,
                queries: {
                  plan: {
                    columns: {
                      id: 'sa.id',
                      number: 'sa.number',
                      container_name: 'vc.name',
                      product_name: 'p.name',
                      quantity: 'sa.quantity',
                    },
                    from: 's:shift_atom',
                    from_as: 'sa',
                    joins: [
                      {
                        join: 's:voc_containers',
                        type: 'left',
                        as:   'vc',
                        on: {
                          $eq: ['sa.container_id', 'vc.id']
                        }
                      },
                      {
                        join: 's:products',
                        type: 'left',
                        as:   'p',
                        on: {
                          $eq: ['sa.product_id', 'p.id']
                        }
                      },
                    ],
                    order: [
                      {$asc: ['sa.id']}
                    ],
                    where: {
                      $eq: [`sa.shift_id`, {$: documentId}]
                    }
                  },
                },
                format: 'xlsx'
              })
          ]).then(((result: ServerResult) => {
              const exportOpContent = result.getOperation('EXPORT').getContent();
              const fToken = exportOpContent.token;
              const aToken = (rootState as any).ubic.token
              const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
              saveAs(fileUrl, 'export.xlsx')

              resolve();
          }));
        });
    }
  }

export const mutations: MutationTree<ShiftAtomState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  SET_FROM_DATA(state, {index, field, newValue}) {
    console.log('------>', index, field, newValue)
    const _idx = state.relatedPlansList.indexOf(index)
    state.relatedPlansList[_idx][field] = newValue;
  }

  // SET_DEAL_DATA(state, data) {
  //     const schema = data.schema;
  //     const document = data.documents[0];

  //     state.document = document
  // },

  // SET_DEAL_PRODRUCTS(state, data) {
  //     state.products = data.documents;
  // },

  // SET_STATUSES_INFO(state, {inWorkStatus, formationStatus}) {
  //     state.inWorkStatus = inWorkStatus;
  //     state.formationStatus = formationStatus;
  // },
};

export const getters: GetterTree<ShiftAtomState, RootState> = {
  totals : (state: ShiftAtomState) => {
    return {
      sum: state.relatedPlansList.reduce((val: number, item: any) => {
        return val + (parseFloat(item.container_price) || 0)
      }, 0)
    }
  },
  rotatePlan: (state: ShiftAtomState) => {
    const journal = state.relatedPlansList.reduce((prev: any, item: any) => {
      Object.keys(item).map((key: any) => {
        if (!prev[key]){
          prev[key] = [];
        }
        prev[key].push(item[key]);
      })
      prev.rows.push(item)
      return prev
    }, {rows: [], total_weight: []})

    return journal;
  }
};

export const STORE_KEY = '$_shift_atom_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
